import {VGFormSender, VGModal} from "vgapp";
import {normalizeData} from "vgapp/app/utils/js/functions";

document.addEventListener('DOMContentLoaded', () => {
	let formAddressChecker = document.getElementById('form-check-address');
	if (formAddressChecker) {
		VGFormSender.init(formAddressChecker, {
			interceptors: {
				success: true
			},
			callback: {
				afterSuccess: function (form, self, event, data) {
					data = normalizeData(data);
					let response = normalizeData(data.response);

					if (!response.errors) {
						const modal = new VGModal('#modal-request-checker', {
							fields: [
								{
									name: 'response-title',
									value: response.title
								},
								{
									name: 'response-message',
									value: response.message
								}
							]
						});

						modal.show();

						let modalElement = document.getElementById('modal-request-checker');

						modalElement.querySelector('[name=user_address]').value = formAddressChecker.querySelector('#avail-user-address').value;

						modalElement.addEventListener('vg.modal.hide', function () {
							let button = form.querySelector('button[type="submit"]'),
								textElm = button.querySelector('[data-text]'),
								text = textElm.dataset.text;

							button.removeAttribute('disabled');
							textElm.innerText = text;
						});
					}
				}
			}
		});

		ymaps.ready(function () {
			let suggestView = new ymaps.SuggestView("avail-user-address");

			suggestView.events.add('select', function (e) {
				ymaps.geocode(e.get('item').value, {results: 1})
					.then(function (res) {
						let firstGeoObject = res.geoObjects.get(0),
							coordinates = firstGeoObject.geometry.getCoordinates();

						formAddressChecker.querySelector('[name=coordinates]').value = coordinates;
					});
			});

			document.getElementById('avail-user-address').addEventListener('change', () => {
				formAddressChecker.querySelector('[name=coordinates]').value = '';
			});
		});
	}
});
